module.exports = __webpack_public_path__ + "static/media/logotiny.40274e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logotiny.png
// module id = 1072
// module chunks = 0